import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import closeImg from '@/assets/images/mobile/close.webp';
import { inject, observer } from 'mobx-react';
import { getEnvironment } from '@/utils/Mobile';
const UserInfo = (props) => {
    const env = getEnvironment();

    const { grtAi, chatStore } = props.store;

    const { isLogin, studentName, loginAndOutConfig = {} } = grtAi;
    const { logout_config } = loginAndOutConfig;
    const { handleOutLogin, goLogin } = chatStore;
    return (
        <>
            <div className={s['user-info']}>
                <Display show={isLogin}>
                    <div className={s['user-name']}>hi，{studentName}</div>
                    <Display show={logout_config?.can_logout === 1 && !env}>
                        <div className={s['logout-wrap']} onClick={handleOutLogin}>
                            <img src={closeImg} alt="close" />

                            <span>退出</span>
                        </div>
                    </Display>
                </Display>
                <Display show={!isLogin}>
                    <span onClick={goLogin} className={s['login-text']}>
                        请登录
                    </span>
                </Display>
            </div>
        </>
    );
};

export default inject('store')(observer(UserInfo));
